import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';

import * as yup from 'yup';

/** Salary distribution user settings create request body */
export interface SalaryDistributionUserFormInterface {
  /** Related user */
  user: UserFindInterface;
  /** User month salary amount */
  amount: number;
}

/** Salary distribution user settings create request body - DTO schema */
export const SalaryDistributionUserFormDto = SerdeDtoClass.create<SalaryDistributionUserFormInterface>(DocumentDtoKeysEnum.SALARY_DISTRIBUTION_USER_FORM_DTO, {
  user: {
    label: 'Пользователь',
    checkers: [
      SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO,
      SecurityBackendValidatorsEnum.USER_HAS_CONTRAGENT_BY_DTO,
    ],
    serializer: yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    }) as yup.Schema<any>,
  },
  amount: {
    label: 'Оклад',
    serializer: yup
      .number()
      .positive(DtoMessageEnum.NOT_POSITIVE),
  },
});
